import { render, staticRenderFns } from "./SubclassInfo.vue?vue&type=template&id=c2b54814&scoped=true&"
import script from "./SubclassInfo.vue?vue&type=script&lang=js&"
export * from "./SubclassInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubclassInfo.vue?vue&type=style&index=0&id=c2b54814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b54814",
  null
  
)

export default component.exports